module.exports = {
  API_URL: 'http://127.0.0.1:8000/api',
  ENV: 'local',
  DEBUG: true,
}
